import axios from 'axios';
import { useEffect, useState } from 'react';
import appSettings from 'src/app-settings.json';
import * as Sentry from '@sentry/react';
interface ITermsAndConditions {
  pdfLink: string;
  version: string;
}

interface IUseTermsAndConditions {
  data: ITermsAndConditions | null;
  loading: boolean;
  error: Error | null;
}

export function useTermsAndConditions(): IUseTermsAndConditions {
  const [data, setData] = useState<ITermsAndConditions | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchTermsAndConditions() {
      try {
        if (!appSettings.tosApiDomain) {
          throw new Error('Terms and Conditions API domain is not configured.');
        }
        const response = await axios.get<ITermsAndConditions>(`${appSettings.tosApiDomain}content`);
        setData(response.data);
      } catch (err) {
        Sentry.captureException(err);
        setError(err as Error);
      }
      setLoading(false);
    }

    fetchTermsAndConditions();
  }, []);

  return { data, loading, error };
}
